export const examsTemplate = `
<!DOCTYPE html>
<html lang="es">

<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="x-apple-disable-message-reformatting" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <title>UC CHRISTUS | Orden médica - Indicaciones</title>

    <style>
        html,
        body {
            margin: 0 !important;
            padding: 0 !important;
            height: 100% !important;
            width: 100% !important;
        }

        * {
            -ms-text-size-adjust: 100%;
            -webkit-text-size-adjust: 100%;
        }

        table,
        td {
            mso-table-lspace: 0pt;
            mso-table-rspace: 0pt;
            border-collapse: collapse !important;
        }

        a {
            text-decoration: none;
        }

        img {
            -ms-interpolation-mode: bicubic;
        }

        @media screen and (max-width: 640px) {
            .container {
                width: 100% !important;
            }

            .px {
                padding-left: 16px !important;
                padding-right: 16px !important;
            }

            .stack {
                display: block !important;
                width: 100% !important;
            }

            .hide-m {
                display: none !important;
            }

            .row-pad {
                padding: 12px 12px !important;
            }

            .btn {
                width: 100% !important;
            }

            .btn td {
                width: 100% !important;
            }

            .btn a {
                display: block !important;
                width: 100% !important;
            }

            .btn-wrap {
                padding-top: 10px !important;
                padding-left: 0 !important;
                text-align: left !important;
            }

            .btn-wrap-2 {
                padding-top: 10px !important;
                padding-left: 0 !important;
                text-align: left !important;
            }

            .btn-label {
                display: none !important;
            }

            .card-btn-cell {
                text-align: center !important;
                padding-top: 8px !important;
            }
        }

        table.rounded {
            border-collapse: separate !important;
        }
    </style>
</head>

<body style="margin: 0; padding: 0; background: #f4f5f8; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif; color: #3b4752;">

    <!-- Preheader oculto -->
    <div style="display: none; max-height: 0; overflow: hidden; opacity: 0; color: transparent; font-size: 1px; line-height: 1px;">
        Agenda fácilmente los exámenes indicados por tu médico. Revisa la orden adjunta y selecciona tu examen para elegir lugar, fecha y hora.
    </div>

    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background: #f4f5f8; padding: 24px 12px;">
        <tr>
            <td align="center">
                <table role="presentation" class="container" width="640" cellpadding="0" cellspacing="0" style="width: 640px; max-width: 640px; background: #ffffff; border: 1px solid #e6e8ee; border-radius: 16px; overflow: hidden;">

                    <!-- ═══ HEADER ═══ -->
                    <tr>
                        <td style="background: #ffffff; padding: 18px 20px;">
                            <table role="presentation" width="100%" cellpadding="0" cellspacing="0">
                                <tr>
                                    <td class="stack" style="vertical-align: middle;">
                                        <img border="0" width="200" height="25"
                                            src="https://s3.us-west-2.amazonaws.com/recursosweb.pub.prd.usw2/imagenes/logo-n-uc.png"
                                            alt="UC CHRISTUS"
                                            style="display: block; border: 0; outline: none; text-decoration: none;" />
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <!-- ═══ LISTA DE EXÁMENES ═══ -->
                    <tr>
                        <td class="px" style="padding: 10px 24px 18px 24px;">
                            <table role="presentation" width="100%" cellpadding="0" cellspacing="0">
                                <!-- Título -->
                                <tr>
                                    <td style="font-size: 15px; font-weight: 900; color: #671e75; text-transform: uppercase; padding-top: 6px;">
                                        Indicaciones Médicas
                                    </td>
                                </tr>
                                <!-- Subtítulo -->
                                <tr>
                                    <td style="font-size: 12px; color: #53565a; line-height: 1.5; padding-top: 6px;">
                                        Revisa si el examen es con agenda o por orden de llegada. Si agendas por el link, <strong>accedes directo y no necesitas subir la orden</strong>
                                    </td>
                                </tr>
                                <!-- Spacer -->
                                <tr>
                                    <td style="height: 12px; font-size: 0; line-height: 0;">&nbsp;</td>
                                </tr>
                                <!-- Tabla de botones -->
                                <tr>
                                    <td>
                                        <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="border: 1px solid #eef0f4; border-radius: 12px; overflow: hidden;">
                                            $linksButtons$
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <!-- ═══ NOTA LEGAL ═══ -->
                    <tr>
                        <td class="px" style="padding: 0 24px 18px 24px;">
                            <p style="font-size: 11px; color: #9e9e9e; font-style: italic; margin: 0; line-height: 1.5;">
                                * Ten en cuenta que la modalidad de atención varía según el examen. Algunos pueden agendarse en línea o llamando al 22 676 7000, mientras que otros funcionan por orden de llegada o servicio a domicilio.
                            </p>
                        </td>
                    </tr>

                    <!-- ═══ DATOS DEL PACIENTE ═══ -->
                    <tr>
                        <td class="px" style="padding: 0 24px 18px 24px;">
                            <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background: #eef5ff; border-radius: 8px;">
                                <tr>
                                    <td style="padding: 16px; vertical-align: top; width: 33%;">
                                        <p style="font-weight: 700; font-size: 12px; line-height: 20px; color: #373737; margin: 0 0 4px 0;">Paciente</p>
                                        <p style="font-weight: 500; font-size: 11px; color: #373737; margin: 0;">$patientFullname$</p>
                                    </td>
                                    <td style="padding: 16px; vertical-align: top; width: 33%;">
                                        <p style="font-weight: 700; font-size: 12px; line-height: 20px; color: #373737; margin: 0 0 4px 0;">Médico tratante</p>
                                        <p style="font-weight: 500; font-size: 11px; color: #373737; margin: 0;">$professionalFullname$</p>
                                    </td>
                                    <td style="padding: 16px; vertical-align: top; width: 33%;">
                                        <p style="font-weight: 700; font-size: 12px; line-height: 20px; color: #373737; margin: 0 0 4px 0;">Área de consulta</p>
                                        <p style="font-weight: 500; font-size: 11px; color: #373737; margin: 0;">$professionalSpecialty$</p>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <!-- ═══ AYUDA ═══ -->
                    <tr>
                        <td class="px" style="padding: 0 24px 18px 24px;">
                            <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background: #f7f7fb; border-radius: 8px;">
                                <tr>
                                    <td style="padding: 22px;">
                                        <table role="presentation" width="100%" cellpadding="0" cellspacing="0">
                                            <!-- Título ayuda -->
                                            <tr>
                                                <td style="font-size: 13px; font-weight: 900; color: #3b4752; padding-bottom: 8px;">
                                                    ¿Necesitas ayuda?
                                                </td>
                                            </tr>
                                            <!-- Texto 1 -->
                                            <tr>
                                                <td style="font-size: 12px; color: #3b4752; line-height: 1.5; padding-bottom: 8px;">
                                                    Llámanos al <span style="color: #0768d0;"><strong>22 676 7000</strong></span> o visita nuestro
                                                    <a href="https://www.ucchristus.cl/centro-de-ayuda" style="color: #0768d0; font-weight: 800;">Centro de ayuda</a>.
                                                </td>
                                            </tr>
                                            <!-- Texto 2 -->
                                            <tr>
                                                <td style="font-size: 12px; color: #3b4752; line-height: 1.5; padding-bottom: 10px;">
                                                    Accede a todas tus órdenes médicas y resultados en nuestro Portal Paciente:
                                                </td>
                                            </tr>
                                            <!-- Tarjeta Portal Paciente (tabla en lugar de div) -->
                                            <tr>
                                                <td>
                                                    <table role="presentation" class="rounded" width="100%" cellpadding="0" cellspacing="0" style="border-radius: 8px; border: 1px solid #671e75; border-collapse: separate;">
                                                        <tr>
                                                            <td style="padding: 12px; background: #ffffff; border-radius: 8px;">
                                                                <a href="https://mi.ucchristus.cl/Usuarios/Login" style="color: #671e75; display: block; font-size: 12px;">
                                                                    <strong>Portal Paciente UC CHRISTUS</strong>
                                                                </a>
                                                                <span style="display: block; margin-top: 4px; font-size: 12px; color: #53565a;">mi.ucchristus.cl</span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <!-- ═══ INFORMACIÓN IMPORTANTE ═══ -->
                    <tr>
                        <td class="px" style="padding: 0 24px 18px 24px;">
                            <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background: #eef5ff; border-radius: 8px;">
                                <tr>
                                    <td style="padding: 16px; vertical-align: top;">
                                        <p style="font-weight: 700; font-size: 16px; line-height: 20px; color: #373737; margin: 0 0 10px 0;">
                                            Información Importante
                                        </p>
                                        <p style="font-weight: 500; font-size: 11px; color: #373737; margin: 0 0 8px 0; line-height: 1.6;">
                                            Contamos con convenios <strong>FONASA e Isapre</strong> para exámenes, imágenes y procedimientos en nuestros Centros Médicos.
                                        </p>
                                        <p style="font-weight: 500; font-size: 11px; color: #373737; margin: 0; line-height: 1.6;">
                                            ¿Prefieres atención en casa?
                                            <a href="https://www.ucchristus.cl/examenes-y-procedimientos/laboratorio-clinico/toma-de-muestras/domicilios" style="color: #0768d0; font-weight: 700;">
                                                Solicita Toma de Muestras a domicilio aquí
                                            </a>.
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <!-- ═══ FOOTER ═══ -->
                    <tr>
                        <td style="background: #3b4752; padding: 16px 20px; border-radius: 0 0 16px 16px;" class="px">
                            <p style="color: #ffffff; font-size: 12px; line-height: 1.6; margin: 0;">
                                <strong>Ordenes UC CHRISTUS</strong> — Notificación de <strong>orden médica</strong> e <strong>indicaciones</strong>.
                            </p>
                            <p style="margin: 10px 0 0 0; color: #a8b0b8; font-size: 11px; line-height: 1.5;">
                                Palabras clave: Orden médica, Indicaciones, Exámenes, Laboratorio, Agendar, RME.
                            </p>
                            <p style="margin: 10px 0 0 0; color: #a8b0b8; font-size: 11px; line-height: 1.5;">
                                © 2026 Red de Salud UC CHRISTUS
                            </p>
                        </td>
                    </tr>

                </table>
            </td>
        </tr>
    </table>
</body>

</html>
`;

export const examButtonHeaderPartial = `$items$`;

export const examsImagesTeamTemplate = `
<html>
<head>
  <style>
    * { font-family: Tahoma, Ginebra, sans-serif; }
    p { color: #686666; font-size: 14px; line-height: 19px; }
  </style>
</head>
<body>
<div>
  <!--[if gte mso 9]>
  <v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
    <v:fill type="tile"></v:fill>
  </v:background>
  <![endif]-->
  <table style="padding-left: 20px;" width="90%">
    <tr>
      <td align="left" style="padding-bottom: 20px; padding-top: 20px">
        <img src="https://www.ucchristus.cl/assets/images/logo.png" alt="Logo" width="292"/>
      </td>
    <tr><td>&nbsp;</td></tr>
    <tr>
    <tr>
      <td style="color: #848484;">
        <p>Estimados,</p>
        <p>Encuentren adjuntas indicaciones de imágenes del paciente $patientFullname$ $patientDocumentNumber$.</p>

        $teamAccess$
      </td>
    </tr>
    </tr>
    <tr><td>&nbsp;</td></tr>
    <tr><td style="border-bottom: 1px solid #dddddd"></td></tr>
    <tr>
      <td>
        <table width="100%">
          <tr>
            <td>
              <table width="100%" border="0">
                <tr>
                  <td valign="top">
                    <p style="text-align: left;color: #5a5a5a;font-size: 11px;line-height: 20px;">
                      <span style="font-weight: bold"> Red de Salud UC CHRISTUS.</span> <br/>
                      Mesa Central Hospital Cl&iacute;nico: 22 354 3000 <br/>
                      Rescate Ambulancia: 800 265 265 <br/>
                      Reserva de Horas: 22 676 7000
                    </p>
                  </td>
                  <td valign="top" width="30">&nbsp;</td>
                  <td valign="top">
                    <table width="100%" border="0">
                      <tr>
                        <td>&nbsp;</td>
                      </tr>
                      <tr>
                        <td valign="top" width="16">&nbsp;</td>
                        <td valign="top" width="1">
                          <a target="_blank" href="https://www.facebook.com/UCCHRISTUS">
                            <img src="https://www.ucchristus.cl/assets/images/rs1.png" width="20"/>
                          </a>
                        </td>
                        <td valign="top" width="1">
                          <a target="_blank"
                             href="https://www.instagram.com/ucchristus/?hl=es-la">
                            <img src="https://www.ucchristus.cl/assets/images/rs4.png" width="20"/>
                          </a>
                        </td>
                        <td valign="top" width="1">
                          <a target="_blank" href="https://twitter.com/ucchristus">
                            <img src="https://www.ucchristus.cl/assets/images/rs2.png" width="20"/>
                          </a>
                        </td>
                        <td valign="top" width="1">
                          <a target="_blank"
                             href="https://cl.linkedin.com/company/ucchristus">
                            <img src="https://www.ucchristus.cl/assets/images/rs5.png" width="20"/>
                          </a>
                        </td>
                        <td valign="top" width="1">
                          <a target="_blank" href="https://www.youtube.com/user/UCCHRISTUS">
                            <img src="https://www.ucchristus.cl/assets/images/rs3.png" width="20"/>
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td height="88"></td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</div>
</body>
</html>
`;

export const examButtonLinkPartial = `
<table role="presentation" width="100%" align="center" cellpadding="0" cellspacing="0" style="width: 100%; min-width: 100%; border: 1px solid #e6e8ee; border-radius: 12px; overflow: hidden; margin: 0 auto 10px auto; font-family: sans-serif;">
  <tr>
    <td align="left" style="padding: 12px 14px; vertical-align: middle;">
      <div style="font-size: 13px; font-weight: 900; color: #3b4752; text-transform: uppercase; line-height: 1.25;">$serviceName$</div>
      $fonasaLine$
      <div style="margin-top: 3px; font-size: 11px; color: #53565a;">Agenda directo sin subir la orden.</div>
    </td>
    <td class="card-btn-cell" align="right" style="padding: 12px 14px; vertical-align: middle; white-space: nowrap;">
      $domicilio$
      <a href="$link$" style="display: inline-block; background: #0768d0; padding: 8px 12px; border-radius: 8px; color: #ffffff; font-size: 14px; font-weight: 600; text-decoration: none; white-space: nowrap; word-break: keep-all;">Agendar&nbsp;Presencial</a>
      </td>
  </tr>
</table>
`;

export const examButtonDirectPartial = `
<table role="presentation" width="100%" align="center" cellpadding="0" cellspacing="0" style="width: 100%; min-width: 100%; border: 1px solid #e6e8ee; border-radius: 12px; overflow: hidden; margin: 0 auto 10px auto; font-family: sans-serif;">
  <tr>
    <td align="left" style="padding: 12px; vertical-align: middle;">
      <div style="font-size: 13px; font-weight: 900; color: #3b4752; text-transform: uppercase; line-height: 1.25;">$serviceName$</div>
      $fonasaLine$
      <div style="margin-top: 3px; font-size: 11px; color: #53565a;">Modalidad: atención por orden de llegada.</div>
    </td>
    <td class="card-btn-cell" align="right" style="padding: 12px; vertical-align: middle; white-space: nowrap;">
      <span style="display: inline-block; border: 1px solid #e6e8ee; color: #53565a; font-weight: 900; font-size: 14px; padding: 8px; border-radius: 8px; white-space: nowrap; word-break: keep-all;">Orden&nbsp;de&nbsp;llegada</span>
    </td>
  </tr>
</table>
`;

export const examButtonCallPartial = `
<table role="presentation" width="100%" cellpadding="0" cellspacing="0"
  style="border:1px solid #e6e8ee; border-radius:12px; overflow:hidden; margin-bottom:10px; font-family:sans-serif;">
  <tr>
    <td style="padding:12px 14px; vertical-align:middle;">
      <div style="font-size:13px; font-weight:900; color:#3b4752; text-transform:uppercase; line-height:1.25;">$serviceName$</div>
      $fonasaLine$
      <div style="margin-top:3px; font-size:11px; color:#53565a;">Modalidad: agendar por teléfono.</div>
    </td>
    <td class="card-btn-cell" align="right" style="padding:12px 14px; vertical-align:middle; white-space:nowrap;">
      <span style="background:#fff6e0; display:inline-block; border:1px solid #e6e8ee; color:#53565a; font-weight:900; font-size:14px; padding:6px 10px; border-radius:8px; margin-right:6px; margin-bottom:6px;">Call center</span><a href="tel:226767000" style="font-size:14px; color:#3b4752; font-weight:900; text-decoration:none; white-space:nowrap;">2&#x202F;2676&#x202F;7000</a>
    </td>
  </tr>
</table>
`;
